import { ThemeIcon } from '@mantine/core';
import { IconCheck, IconX, IconLoader } from '@tabler/icons-react';
import { FC } from 'react';

import { FORM_STATUS } from '@data-access';

const STYLES = {
  [FORM_STATUS.FINISHED]: {
    icon: IconCheck,
    color: 'pf-green',
  },
  [FORM_STATUS.INCOMPLETE]: {
    icon: IconX,
    color: 'gray.2',
  },

  [FORM_STATUS.PENDING]: {
    icon: IconLoader,
    color: 'yellow',
  },
};

export const ReportingStatus: FC<{ status: FORM_STATUS }> = ({ status }) => {
  if (
    status === FORM_STATUS.ERROR ||
    status === FORM_STATUS.REJECTED ||
    status === FORM_STATUS.WAITING ||
    status === FORM_STATUS.NO_MODULATION
  ) {
    return 'not implemented';
  }

  const Icon = STYLES[status].icon;
  const color = STYLES[status].color;

  return (
    <ThemeIcon color={color}>
      <Icon stroke={3.5} style={{ width: '80%', height: '80%' }} />
    </ThemeIcon>
  );
};
